/* @fflow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import { connect } from 'react-redux';

import { fetchProjects } from 'ducks/projects';
import { setMessage } from 'ducks/message';
import { setModal } from 'ducks/modal';
import Row from 'components/UIKit/Flex/Row';
import style from 'components/Upload/style';

import Button from 'components/UIKit/Button/Button';
import { ExternalLink } from 'components/Links';
import { release } from 'ducks/workflow';

class Release extends Component {
  // $FlowIssue https://github.com/facebook/flow/issues/850
  static propTypes = {
    program: PropTypes.string,
    project: PropTypes.string,
  };

  handleFinish() {
    this.props.dispatch(setMessage(`${program}-${project} release is requested`));
    this.props.dispatch(fetchProjects({ ids: this.props.projects.items.map(x => x.project_id) }));
  }

  async handleRelease(program, project) {
    this.props.dispatch(release({program, project}))
      .then(
        () => {
          this.props.dispatch(fetchProjects({ ids: this.props.projects.items.map(x => x.project_id) }));
        },
        () => this.props.dispatch(setMessage(`Error requesting release for ${program}-${project}`))
      );
      this.props.dispatch(setModal({ Component: null }));

  }

  render(): React.Element {
    let { program, project, dispatch } = this.props;

    return (
      <div style={{ height: `100%` }}>
        <Row style={{...style.wizardHeader, justifyContent: 'space-between'}}>
          <span style={{ ...style.wizardNavItem,
            padding: '0 1rem', textTransform: 'uppercase' }}>
          Release {program}-{project} Submitted and Processed Data to the GDC Data Portal
          </span>
          <a style={{
            zIndex: 20,
            padding: '0 1rem',
            textDecoration: 'none',
            fontSize: '1em',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: 'rgb(66, 66, 66)',
          }}
            onClick={() => dispatch(setModal({ Component: null }))}
          >
             CANCEL &#10005;
          </a>
        </Row>
        <div style={{ height: `calc(100% - 4.8rem)`}}>
          <div style={{ display: 'flex',
                      flexDirection: 'column',
                      height: `100%`,
                      width: `90%`,
                      margin: `0 auto`,
                      boxSizing: `border-box`,
                      padding: `1rem 1rem`,
                      alignItems: 'center'
                      }}>
            <p>DISCLAIMER:  Released data will be made available through the <ExternalLink href="https://gdc.cancer.gov/access-data/gdc-data-portal">GDC Data Portal</ExternalLink> and other GDC data access tools such as the <ExternalLink href="https://gdc.cancer.gov/access-data/gdc-data-transfer-tool">GDC Data Transfer Tool (DTT)</ExternalLink> and the <ExternalLink href="https://gdc.cancer.gov/developers/gdc-application-programming-interface-api">GDC Application Programming Interface (API)</ExternalLink>. Only dbGaP users authorized to view the project data will be able to view controlled data. For additional instructions on accessing data through the GDC Data Portal, please see the <ExternalLink href="http://docs.gdc.cancer.gov/Data_Portal/Users_Guide/Getting_Started/">GDC Data Portal User's Guide</ExternalLink>. For instructions on accessing data through other GDC data access tools such as the GDC DTT and API, please see the <ExternalLink href="http://docs.gdc.cancer.gov/API/Users_Guide/Getting_Started/">GDC API User's Guide</ExternalLink> and the <ExternalLink href="http://docs.gdc.cancer.gov/Data_Transfer_Tool/Users_Guide/Getting_Started/">GDC Data Transfer Tool (DTT) User's Guide</ExternalLink>, respectively.
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Button style={{ margin: '1.5rem', padding: '1rem' }} onClick={() => this.handleRelease(program, project)}>
                Release Submitted and Processed Data
              </Button>
            </div>
          </div>
        </div>
    </div>
    );
  }
}

export default connect(
  state => ({
    projects: state.projects,
    workflow: state.workflow
  })
)(Release);
